import { render } from "./OidoIcon.vue?vue&type=template&id=3df823f6"
import script from "./OidoIcon.vue?vue&type=script&lang=js"
export * from "./OidoIcon.vue?vue&type=script&lang=js"

import "./OidoIcon.vue?vue&type=style&index=0&id=3df823f6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__